<template>
  <div>
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="green">
      <span class="body-1 font-weight-light white--text"
        v-html="message.success">
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          class="body-1 font-weight-bold text-capitalize"
          color="white"
          icon
          v-bind="attrs"
          @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="dialog.form"
      @keydown.esc="dialog.form = false"
      :fullscreen="dialog.fullscreen"
      width="625"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          {{ form.id === '' ? 'Tambah' : 'Ubah' }}

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.form = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text
          class="mt-4">
          <ValidationObserver 
            ref="form">
            <v-form>
              <ValidationProvider 
                name="name" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Nama Unit
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>

                <v-text-field
                  filled
                  rounded
                  dense
                  :color="set_color"
                  hide-details
                  placeholder="Contoh. Finance"

                  v-uppercase

                  v-model="form.name"
                  :success="form.name !== '' && valid"
                  :error-messages="errors"
                  class="mb-6"
                  style="border-radius: 10px; width: 70%;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Nama {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.name !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <ValidationProvider 
                name="code" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Kode
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>

                <v-text-field
                  filled
                  rounded
                  dense
                  :color="set_color"
                  hide-details
                  type="number"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  min="0"
                  
                  placeholder="Contoh. 001"

                  v-model="form.code"
                  :success="form.code !== '' && valid"
                  :error-messages="errors"
                  class="mb-6"
                  style="border-radius: 10px; width: 40%;">
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Kode {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.code !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>

              <v-row>
                <v-col
                  cols="12"
                  md="6"
                  class="py-0">
                  <div>
                    <div class="body-2 mb-2">
                      <!-- <span class="red--text">*</span> -->
                      Jam Presensi Datang
                      <span>
                        (boleh dikosongi)
                      </span>
                    </div>

                    <v-menu
                      ref="start_time"
                      v-model="time.start"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="form.absen_start_time"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px">
                      <template v-slot:activator="{ on, attrs }">
                        <ValidationProvider 
                          name="Jam Presensi Datang" 
                          v-slot="{ errors, valid }">
                          <v-text-field
                            v-on:keyup.enter="save"
                            readonly
                            filled
                            rounded
                            dense
                            :color="set_color"
                            placeholder="Contoh. 09:00"

                            hide-details

                            clearable
                            @click:clear="form.absen_start_time = ''; form.absen_end_time = '';"
                            v-on="on"
                            v-bind="attrs"

                            v-model="form.absen_start_time"
                            :success="form.absen_start_time !== '' && form.absen_start_time !== null && valid"
                            :error-messages="errors"
                            class="mb-6"
                            style="border-radius: 10px;">
                            <template v-slot:append-outer>
                              <div v-if="errors.length > 0">
                                <v-tooltip top color="#ff5252">
                                  <template v-slot:activator="{ on }">
                                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                  </template>
                                  
                                  Jam Presensi Datang {{ errors[0] }}
                                </v-tooltip>
                              </div>

                              <div v-if="form.absen_start_time !== '' && form.absen_start_time !== null && valid">
                                <v-icon color="success">mdi-check-circle-outline</v-icon>
                              </div>
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </template>

                      <v-time-picker
                        v-if="time.start"
                        v-model="form.absen_start_time"
                        full-width
                        :color="set_color"
                        format="24hr"
                        @click:minute="$refs.start_time.save(`${form.absen_start_time}`); form.absen_end_time = '';">
                      </v-time-picker>
                    </v-menu>
                  </div>
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                  class="py-0">
                  <div>
                    <div class="body-2 mb-2">
                      <!-- <span class="red--text">*</span> -->
                      Jam Presensi Pulang
                      <span>
                        (boleh dikosongi)
                      </span>
                    </div>
                    
                    <v-menu
                      ref="end_time"
                      v-model="time.end"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="form.absen_end_time"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px">
                      <template v-slot:activator="{ on, attrs }">
                        <ValidationProvider 
                          name="Jam Presensi Pulang" 
                          v-slot="{ errors, valid }">
                          <v-text-field
                            v-on:keyup.enter="save"
                            readonly
                            filled
                            rounded
                            dense
                            :color="set_color"
                            placeholder="Contoh. 17:00"
                            
                            hide-details

                            clearable
                            @click:clear="form.absen_end_time = ''"
                            v-on="on"
                            v-bind="attrs"

                            v-model="form.absen_end_time"
                            :success="form.absen_end_time !== '' && form.absen_end_time !== null && valid"
                            :error-messages="errors"
                            class="mb-6"
                            style="border-radius: 10px;">
                            <template v-slot:append-outer>
                              <div v-if="errors.length > 0">
                                <v-tooltip top color="#ff5252">
                                  <template v-slot:activator="{ on }">
                                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                  </template>
                                  
                                  Jam Presensi Pulang {{ errors[0] }}
                                </v-tooltip>
                              </div>

                              <div v-if="form.absen_end_time !== '' && form.absen_end_time !== null && valid">
                                <v-icon color="success">mdi-check-circle-outline</v-icon>
                              </div>
                            </template>
                          </v-text-field>
                        </ValidationProvider>
                      </template>

                      <v-time-picker
                        v-if="time.end"
                        :min="form.absen_start_time"
                        v-model="form.absen_end_time"
                        full-width
                        :color="set_color"
                        format="24hr"
                        @click:minute="$refs.end_time.save(`${form.absen_end_time}`)">
                      </v-time-picker>
                    </v-menu>
                  </div>
                </v-col>
              </v-row>

              <div
                class="mb-6">
                <div class="body-2 mb-2">
                  Silahkan geser marker untuk menentukan koordinat lokasi dibawah ini:
                </div>

                <gmap-map
                  :center="center"
                  :zoom="12"
                  :options="{
                    zoomControl: true,
                    mapTypeControl: false,
                    scaleControl: false,
                    streetViewControl: false,
                    rotateControl: false,
                    fullscreenControl: true,
                    disableDefaultUi: false
                  }"
                  :clickable="true"
                  @click="updatePlace"
                  style="width: 100%; height: 300px;">

                  <gmap-marker
                    :position="center"
                    :draggable="true"
                    @drag="updatePlace"
                    @click="center=center">
                  </gmap-marker>
                </gmap-map>
              </div>

              <v-row>
                <v-col
                  cols="12"
                  md="6"
                  class="py-0">
                  <ValidationProvider 
                    name="latitude" 
                    v-slot="{ valid }">
                    <div class="body-2 mb-2">
                      Latitude
                      <span>
                        (boleh dikosongi)
                      </span>
                    </div>

                    <v-text-field
                      filled
                      rounded
                      dense
                      disabled
                      :color="set_color"
                      hide-details
                      type="number"
                      placeholder="Contoh. -7.689743"

                      v-uppercase

                      v-model="form.latitude"
                      :success="form.latitude !== '' && valid"
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="form.latitude !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                  class="py-0">
                  <ValidationProvider 
                    name="longitude" 
                    v-slot="{ valid }">
                    <div class="body-2 mb-2">
                      Longitude
                      <span>
                        (boleh dikosongi)
                      </span>
                    </div>

                    <v-text-field
                      filled
                      rounded
                      dense
                      disabled
                      :color="set_color"
                      hide-details
                      type="number"
                      placeholder="Contoh. 110.606819"

                      v-uppercase

                      v-model="form.longitude"
                      :success="form.longitude !== '' && valid"
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="form.longitude !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>

              <ValidationProvider 
                name="attended_range" 
                v-slot="{ valid }">
                <div class="body-2 mb-2">
                  Range
                  <span>
                    (boleh dikosongi)
                  </span>
                </div>

                <v-text-field
                  filled
                  rounded
                  dense
                  :color="set_color"
                  hide-details
                  placeholder="Contoh. 50"

                  v-uppercase

                  v-model="form.attended_range"
                  :success="form.attended_range !== '' && valid"
                  class="mb-6"
                  style="border-radius: 10px; width: 40%;">
                  <template v-slot:append-outer>
                    <div v-if="form.attended_range !== '' && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-form>
          </ValidationObserver>

          <div v-if="message.error.length > 0"
            class="text-center my-4">
            <div
              class="error--text d-flex align-center">
              <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
              
              <span
                class="ml-1">
                {{ message.error }}
              </span>
            </div>
          </div>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="green"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            v-on:keyup.enter="save()"
            @click="save()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Simpan
          </v-btn>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="dialog.form = false; reset();">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.delete"
      @keydown.esc="dialog.delete = false"
      :fullscreen="dialog.fullscreen"
      width="500"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          Hapus Data

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text class="body-1 font-weight-light text-first mt-3">
          Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?

          <v-card v-if="selected.node.children !== undefined && selected.node.children.length > 0"
            flat
            :color="set_color_rgb_soft"
            :style="`border: 2px solid ${set_color};`"
            class="pa-4 mt-4"
            style="border-radius: 10px;">
            <div
              class="body-2 font-weight-bold black--text mb-2">
              Catatan.
            </div>

            <div
              class="body-2"
              style="opacity: 70%;">
              Jika Anda menghapus data yang Anda pilih, maka sub data juga akan dihapus.
            </div>
          </v-card>
        </v-card-text>

        <div v-if="message.error.length > 0"
          class="text-center mx-6 my-4">
          <div
            class="error--text d-flex align-center">
            <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
            
            <span
              class="ml-1">
              {{ message.error }}
            </span>
          </div>
        </div>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="green"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.delete"
            :loading="process.delete"
            @click="deletes()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Ya, Hapus
          </v-btn>

          <v-btn
            outlined
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.delete"
            @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.map"
      @keydown.esc="dialog.map = false"
      :fullscreen="dialog.fullscreen"
      width="1000"
      persistent
      scrollable>
      <v-card v-if="markers.length > 0"
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
        class="pa-2">
        <v-card-title 
          class="d-flex align-center py-0 px-3 text-right popup-header">
          {{ markers[0].name }}

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            :color="set_color">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.map = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>
        
        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text
          class="mt-4">
          <gmap-map
            ref="gmap"
            :center="center"
            :zoom="12"
            :scrollwheel="false"
            style="width:100%;"
            :style="!dialog.fullscreen ? 'height: calc(100vh - 300px);' : 'height: calc(100vh - 100px);'">

            <gmap-marker
              v-for="(item, index) in markers"
              :key="index"
              :position="item.latlng"
              :icon="item.icon">
            </gmap-marker>
          </gmap-map>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col 
        cols="12"
        class="py-0">
        <v-card 
          flat 
          style="border: 1px solid #E0E0E0;">
          <v-card-text>
            <v-row>
              <v-col 
                cols="12" 
                md="3">
                <div
                  class="d-flex align-center">
                  <v-btn
                    to="/unit/structure/regulation"
                    color="#E5E7EB"
                    elevation="0"
                    class="text-capitalize d-flex align-center"
                    style="border-radius: 10px;">
                    <v-icon>mdi-vector-polyline-edit</v-icon>

                    <span
                      class="ml-1">
                      Lihat Peraturan Perusahaan
                    </span>
                  </v-btn>
                </div>
              </v-col>

              <v-col 
                cols="12" 
                md="9">
                <div
                  class="d-flex align-center justify-end">
                  <v-btn
                    @click="zoomIn"
                    :color="set_color"
                    fab
                    width="36"
                    height="36"
                    elevation="0"
                    class="mx-2"
                    style="border-radius: 10px;">
                    <v-icon color="white">mdi-magnify-plus-outline</v-icon>
                  </v-btn>

                  <!-- <v-btn
                    @click="capture"
                    :loading="process.caps"
                    :disabled="process.caps"
                    :color="set_color"
                    outlined
                    fab
                    width="36"
                    height="36"
                    elevation="0"
                    class="mx-2"
                    :style="`color: ${set_color};`"
                    style="border-radius: 10px;">
                    <v-icon :color="set_color">mdi-fit-to-screen-outline</v-icon>
                  </v-btn> -->

                  <v-btn
                    @click="zoomOut"
                    :color="set_color"
                    fab
                    width="36"
                    height="36"
                    elevation="0"
                    class="mx-2"
                    style="border-radius: 10px;">
                    <v-icon color="white">mdi-magnify-minus-outline</v-icon>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card
            flat
            class="pa-4"
            :color="set_color_rgb_soft"
            style="border-radius: 0px;">
            <div
              class="d-flex align-center">
              <!-- <div
                style="font-weight: 600;">
                Struktur Organisasi PT Solusi Digital Manunggal
              </div>

              <div
                class="mx-4">
                <v-divider
                  vertical
                  style="border-right: 2px solid #000000; height: 20px; opacity: 60%;" />
              </div> -->

              <div
                style="font-weight: 600;">
                <span
                  style="opacity: 60%;">
                  Total Unit:
                </span>

                <span>
                  {{ count.unit }}
                </span>
              </div>

              <div
                class="ml-4"
                style="font-weight: 600;">
                <span
                  style="opacity: 60%;">
                  Total Pegawai:
                </span>

                <span>
                  {{ count.user }}
                </span>
              </div>
            </div>
          </v-card>

          <v-card-text>
            <div 
              id="tree"
              @mousewheel="deltaZoom">
              <vue-tree
                ref="tree"
                linkStyle="straight"
                direction="vertical"
                :dataset="list"
                :config="{ nodeWidth: 350, nodeHeight: 100, levelHeight: 250 }"
                :collapse-enabled="true"
                style="width: 100%; height: calc(100vh - 286px);">
                <template v-slot:node="{ node, collapsed }">
                  <v-card
                    min-width="250"
                    :class="collapsed ? '' : ''"
                    style="box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px; border-radius: 10px;"
                    :style="`background: linear-gradient(to right, ${set_color_rgb_down} 0%, #FFFFFF 100%);`">
                    <v-card-text
                      class="pa-3 py-1"
                      style="height: 90px;">
                      <v-list
                        dense
                        class="pa-0"
                        style="background: transparent;">
                        <v-list-item
                          class="px-0">
                          <v-list-item-avatar 
                            class="mr-3 mt-2"
                            size="36"
                            color="#FFFFFF"
                            style="border: 2px solid #FFFFFF;"
                            :style="`box-shadow: rgba(${set_color_rgb_custom}, 0.17) 0px -23px 25px 0px inset, rgba(${set_color_rgb_custom}, 0.15) 0px -36px 30px 0px inset, rgba(${set_color_rgb_custom}, 0.1) 0px -79px 40px 0px inset, rgba(${set_color_rgb_custom}, 0.06) 0px 2px 1px, rgba(${set_color_rgb_custom}, 0.09) 0px 4px 2px, rgba(${set_color_rgb_custom}, 0.09) 0px 8px 4px, rgba(${set_color_rgb_custom}, 0.09) 0px 16px 8px, rgba(${set_color_rgb_custom}, 0.09) 0px 32px 16px;`">
                            <span
                              class="body-1 font-weight-bold white--text">
                              {{ node.name | initial }}
                            </span>
                          </v-list-item-avatar>

                          <v-list-item-content
                            style="max-width: 150px;">
                            <div
                              class="body-2 font-weight-bold black--text three-line text-capitalize mb-1">
                              {{ node.name }}
                            </div>

                            <div
                              class="body-2 black--text"
                              style="opacity: 60%;">
                              Total Pegawai. {{ user.role == 'superadmin' ? node.total_pegawai : count.user }}
                            </div>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-card-text>

                    <v-card-text
                      class="pa-0"
                      style="position: relative; bottom: -17px;">
                      <v-row
                        align="center"
                        justify="center">
                        <v-col
                          :cols="user.role !== 'viewer' ? 2 : 6"
                          class="pa-0">
                          <v-btn
                            :to="`/unit/structure/officer/${node.id}?name=${node.name}`"
                            block
                            :color="set_color"
                            elevation="0"
                            class="px-0"
                            :style="user.role !== 'viewer' ? 'border-radius: 8px 0px 0px 8px;' : 'border-radius: 8px 0px 0px 8px;'">
                            <v-icon small color="white">mdi-account-group-outline</v-icon>
                          </v-btn>
                        </v-col>

                        <v-col
                          :cols="user.role !== 'viewer' ? 2 : 6"
                          class="pa-0">
                          <v-btn
                            @click.stop="toMap(node, $event)"
                            block
                            :color="set_color"
                            elevation="0"
                            class="px-0"
                            :style="user.role !== 'viewer' ? 'border-radius: 0px;' : 'border-radius: 0px 8px 8px 0px;'"
                            style="border-left: 1px solid #FFFFFF;">
                            <v-icon small color="white">mdi-map-marker-circle</v-icon>
                          </v-btn>
                        </v-col>

                        <v-col v-if="user.role !== 'viewer'"
                          cols="2"
                          class="pa-0">
                          <v-btn
                            @click.stop="toAdd(node, $event)"
                            block
                            :color="set_color"
                            elevation="0"
                            class="px-0"
                            style="border-radius: 0px; border-left: 1px solid #FFFFFF;">
                            <v-icon small color="white">mdi-plus-circle-multiple-outline</v-icon>
                          </v-btn>
                        </v-col>

                        <v-col v-if="user.role !== 'viewer'"
                          cols="2"
                          class="pa-0">
                          <v-btn
                            @click.stop="toEdit(node, $event)"
                            block
                            :color="set_color"
                            elevation="0"
                            class="px-0"
                            style="border-radius: 0px; border-left: 1px solid #FFFFFF;">
                            <v-icon small color="white">mdi-circle-edit-outline</v-icon>
                          </v-btn>
                        </v-col>

                        <v-col v-if="user.role !== 'viewer'"
                          cols="2"
                          class="pa-0">
                          <v-btn
                            @click.stop="toDelete(node, $event)"
                            block
                            :color="set_color"
                            elevation="0"
                            class="px-0"
                            style="border-radius: 0px 8px 8px 0px; border-left: 1px solid #FFFFFF;">
                            <v-icon small color="white">mdi-delete-circle-outline</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </template>
              </vue-tree>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import VueTree from "@ssthouse/vue-tree-chart";
  import { get, post, put, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        dialog: {
          fullscreen: false,
          snackbar: false,
          form: false,
          delete: false,
          map: false
        },
        
        selected: {
          node: {},
          delete: []
        },

        list: [],

        center: {
          lat: -7.8032076, 
          lng: 110.3573354
        },
        markers: [],
        
        autocomplete: {
          parent: ''
        },

        count: {
          unit: 0,
          user: 0
        },

        form: {
          id: '',
          parent_id: '',
          code: '',
          name: '',
          latitude: '',
          longitude: '',
          attended_range: '',

          absen_start_time: '',
          absen_end_time: ''
        },
        time: {
          start: false,
          end: false
        },
        process: {
          load: false,
          form: false,
          delete: false,
          caps: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      VueTree
    },
    computed: {
      user () {
        return this.$store.state.user
      },

      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_custom () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `${r}, ${g}, ${b}`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+35}, ${g+37}, ${b}, 0.97)`
      },
      set_color_rgb_soft () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.05)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+70}, ${g+91}, ${b+34})`
      }
    },
    watch: {
      'autocomplete.parent': function() {
        this.fetchParent()
      }
    },
    mounted () {
      this.fetch()
      this.fetchUser()
    },
    methods: {
      async fetch () {
        this.process.load = true

        console.log(this.user)

        let params = {
          limit: 100000,
          position_unit_id: this.user.unit_id
        }

        let url = this.user.role === 'superadmin' ? 'admin/unit' : 'admin/user/position'

        await get(url, { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            this.list = this.user.role === 'superadmin' ? this.changeData(res.results.data) : this.changeDataPosition(res.results.data)

            this.count.unit = this.user.role === 'superadmin' ? res.results.pagination.total_data : res.results.data.length
          }
        })
      },

      async fetchUser () {
        let params = {
          unit_id: this.user.role === 'superadmin' ? '' : this.user.unit_id,
          is_active: 'Aktif'
        }

        await get('admin/user', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.count.user = res.results.pagination.total_data
          }
        })
      },

      changeData (data_array) {
        function filter (array, condition) {
          let result = []

          for (let i = 0; i < array.length; i++) {
            if (condition(array[i])) {
              result.push(array[i])
            }
          }

          return result
        }

        function getChilds (parentKey, items) {
          let subItems = filter(items, function (n) {
            return n.parent_id === parentKey
          })

          let result = []

          for (let i = 0; i < subItems.length; i++) {
            let subItem = subItems[i]

            let kids = getChilds(subItem.id, items)
            if (kids.length) {
              subItem.children = kids
            }

            result.push(subItem)
          }

          if (parentKey.length) {
            return result
          } else {
            return result[0]
          }
        }

        const data = data_array

        let richMediaData = getChilds('0', data)

        return richMediaData
      },

      changeDataPosition (data_array) {
        function filter (array, condition) {
          let result = []

          for (let i = 0; i < array.length; i++) {
            if (condition(array[i])) {
              result.push(array[i])
            }
          }

          return result
        }

        function getChilds (parentKey, items) {
          let subItems = filter(items, function (n) {
            return n.position_par_id === parentKey
          })

          let result = []

          for (let i = 0; i < subItems.length; i++) {
            let subItem = subItems[i]

            let kids = getChilds(subItem.position_id, items)
            if (kids.length) {
              subItem.children = kids
            }

            result.push(subItem)
          }

          if (parentKey.length) {
            return result
          } else {
            return result[0]
          }
        }

        const data = data_array

        let richMediaData = getChilds('0', data)

        return richMediaData
      },

      deltaZoom(event) {
        if (event.deltaY < 0) {
          this.$refs.tree.zoomIn()
        } else {
          this.$refs.tree.zoomOut()
        }
      },
      zoomIn () {
        this.$refs.tree.zoomIn()
      },
      zoomOut () {
        this.$refs.tree.zoomOut()
      },

      toMap(node, event) {
        this.markers = []

        this.dialog.map = true

        this.$gmapApiPromiseLazy().then(() => {
          this.markers.push({
            id: node.id,
            name: node.name,
            latlng: {
              lat: parseFloat(node.latitude), 
              lng: parseFloat(node.longitude)
            },
            icon: {
              url: require('@/assets/image/location_pin.png'),
              scaledSize: new google.maps.Size(50, 50),
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(10, 10)
            }
          })

          this.center = this.markers.length > 0 ? this.markers[0].latlng : this.center
        })
      },
      toAdd(node, event) {
        if (this.$refs.form) this.$refs.form.reset()

        this.dialog.form = true

        this.form = {
          id: '',
          parent_id: node.id,
          name: '',
          code: '',
          latitude: '',
          longitude: '',
          attended_range: '',

          absen_start_time: '',
          absen_end_time: ''
        }

        this.time = {
          start: false,
          end: false
        }

        this.process.form = false

        this.message.error = ''
        
        this.getGeoLocation()
      },
      toEdit(node, event) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.dialog.form = true

        this.form = {
          id: node.id,
          parent_id: node.parent_id,
          name: node.name,
          code: node.code,
          latitude: parseFloat(node.latitude),
          longitude: parseFloat(node.longitude),
          attended_range: node.attended_range,

          absen_start_time: node.absen_start_time,
          absen_end_time: node.absen_end_time
        }

        this.time = {
          start: false,
          end: false
        }

        this.process.form = false

        this.message.error = ''
        
        this.getGeoLocation()
      },

      getGeoLocation() {
        if (this.form.id === '') {
          navigator.geolocation.getCurrentPosition(position => {
            this.center = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            }
          })
        } else {
          this.center = {
            lat: this.form.latitude,
            lng: this.form.longitude
          }
        }
      },
      updatePlace(location) {
        this.center = {
          lat: location.latLng.lat(),
          lng: location.latLng.lng()
        }

        this.form.latitude = location.latLng.lat()
        this.form.longitude = location.latLng.lng()
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = this.form.id.length < 1 ? 'admin/unit/add' : 'admin/unit/update'

          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.fetch()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      toDelete(node, event) {
        this.selected.delete = []

        this.selected.node = node

        this.selected.delete.push(parseInt(node.id))

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post('admin/unit/delete', {
          data: {
            id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {
            this.dialog.delete = false

            this.selected.node = {}
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
          } else {
            this.message.error = res.message
          }
        })
      },

      async capture () {
        this.process.caps = true

        let self = this,
            data = document.getElementById('tree')

        await this.$html2canvas(data, {
          logging: true,
          letterRendering: true,
          allowTaint: false,
          useCORS: true,

          scale: 1920*2/window.innerWidth,

          scrollX: 0,
          scrollY: 0,

          width: 1920,
          height: 1080,
          windowWidth: 7680,
          windowHeight: 4320
        })
        .then(function(canvas) {
          document.body.appendChild(canvas)

          let img = canvas.toDataURL('image/png', 1.0), a = document.createElement('a')

          a.href = img
          a.download = `Pakualaman-${moment().format('DD-MMMM-YYYY', 'id')}-${moment().format('HH:mm:ss', 'id')}.png`
          a.click()

          self.process.caps = false
        })
      }
    }
  }
</script>